<script>
	import { beforeUpdate } from 'svelte';
	export let queryText;
	export let pageStart;
	export let pageSizeDefault;
	export let totalResults;
	let dashboardString = formDashboardString();
	let numberString = numbString();

	beforeUpdate(() => {
		numberString = numbString();
	});

	function formDashboardString() {
		if (!totalResults || totalResults < 1) {
			return 'No result found for';
		} else {
			return 'Displaying Results';
		}
	}

	function numbString() {
		let str = '1-';
		if (pageStart * pageSizeDefault > totalResults) {
			str = `${str}${totalResults}`;
		} else {
			str = `${str}${pageStart * pageSizeDefault}`;
		}
		return str;
	}

</script>

<style>
	* {
		font-family: sans-serif;
	}
	.search-dashboard {
		margin-bottom: .5rem;
	}
	.dashboard {
		margin-top: 1rem;
		padding: 1rem;
		background-color: #f8f8f8;
		border-top: 2px #e5e3e4 solid;
	}
	.query-text {
		padding-left: .25rem;
		color: #006600;
		font-weight: 800;
	}
</style>

{#if queryText && queryText.length > 0}
<div class="search-dashboard">
	<h1>Search Results</h1>
	<div class="dashboard">
		<span>
			{dashboardString}
			{#if totalResults > 0}
				<b>{numberString}</b>
				of
				<b>{totalResults}</b>
			{/if}
		</span>
		<span class="query-text">{decodeURI(queryText)}</span>
	</div>
</div>
{/if}